import { useEffect, useState } from 'react';

const BetaMessage = () => {
  const [isSmallScreen, setIsSmallScreen] = useState(false);

  useEffect(() => {
    const checkScreenSize = () => {
      setIsSmallScreen(window.innerWidth < 850);
    };

    // Check initially
    checkScreenSize();

    // Add event listener for window resize
    window.addEventListener('resize', checkScreenSize);

    // Cleanup
    return () => window.removeEventListener('resize', checkScreenSize);
  }, []);

  useEffect(() => {
    // Add or remove class to body when screen size changes
    if (isSmallScreen) {
      document.body.classList.add('has-beta-message');
    } else {
      document.body.classList.remove('has-beta-message');
    }

    // Cleanup
    return () => {
      document.body.classList.remove('has-beta-message');
    };
  }, [isSmallScreen]);

  if (!isSmallScreen) return null;

  return (
    <div className="fixed top-0 left-0 right-0 bg-minima-orange-2023 text-black p-4 text-center z-50 opacity-90">
      <p className="text-sm font-medium">
        This web app is currently in beta mode and is optimized for desktop screens (850px and
        above). You may experience some display issues on smaller screens.
      </p>
    </div>
  );
};

export default BetaMessage;
